import { render, staticRenderFns } from "./StockModal.vue?vue&type=template&id=969651a2&scoped=true&"
import script from "./StockModal.vue?vue&type=script&lang=js&"
export * from "./StockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969651a2",
  null
  
)

export default component.exports